import { useEffect, useState } from 'react';
import UserForm from './UserForm';
import Spinner from 'components/general/Spinner';

import config from './config';
import { useForm, useActions } from 'utils/hooks';
import * as usersActions from 'store/users/actions';

const EditForm = ({ isOpen, active, drawer, refetchData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const { formState, collectValues, loadValues, isDirty, hasErrors, handleSubmitError } = useForm(
    config,
    {}
  );
  const [updateUser] = useActions([usersActions.updateUser]);

  const load = async () => {
    setLoading(true);
    // const data = await getVesselProfile({ id: active.id });

    // if (data) {
    //   const {
    //     photo,
    //     prefix,
    //     name,
    //     type,
    //     active,
    //     owner,
    //     flag_country,
    //     imo_no,
    //     build_date,
    //     code
    //   } = data;

    //   loadValues({
    //     photo_id: photo,
    //     prefix_id: prefix ? prefix.id : null,
    //     name,
    //     type_id: type,
    //     active,
    //     owner_id: owner,
    //     flag_country_id: flag_country,
    //     imo_no,
    //     build_date,
    //     code
    //   });
    // }

    setLoading(false);
  };

  useEffect(() => {
    if (!isOpen) return;

    load();
  }, [isOpen]);

  const submitForm = async formValues => {
    setIsSubmitting(true);

    // const res = await updateUser({ ...formValues, id: active.id });

    // if (res.id) {
    drawer.close();
    // } else {
    //   handleSubmitError(res);
    // }

    setIsSubmitting(false);
  };

  return loading ? (
    <Spinner className="ms-3 mt-2" />
  ) : (
    <UserForm
      drawer={drawer}
      formState={formState}
      collectValues={collectValues}
      isDirty={isDirty}
      hasErrors={hasErrors}
      submitForm={submitForm}
      isSubmitting={isSubmitting}
    />
  );
};

export default EditForm;
